// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".person-link[data-v-a3fb44be]{margin-top:-16px;padding-bottom:10px;text-align:center}.person-detail[data-v-a3fb44be]{width:100%}.person-item-left[data-v-a3fb44be]{background-color:#fa8b59;float:right}.person-item-left-content[data-v-a3fb44be]{float:right;position:absolute;right:2px}.person-item-right[data-v-a3fb44be]{background-color:#4285f4;padding-left:1px;color:#fff;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
